import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { Moment } from "moment";
import { successAlert } from "../../../style/scss/utils/Alerts";
import Newloader from "../employees/loader";
import { formatDate } from "../../../environment";
import * as XLSX from "xlsx";
import {
  addProductName,
  getAllProductName,
} from "../../../apis/productNameList";
import Select from "react-select";

const initialValues = {
  product_name: "",
};

type ProductListResponse = {
  product_name: string;
  type: string;
  id: any;
  createdAt: string;
};

type ProductListData = {
  key: number;
  id: any;
  product_name: string;
  type: string;
  createdAt: string;
};

const ProductNameList = () => {
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const [allProductListData, setProductListData] = useState<ProductListData[]>(
    []
  );
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [loader, setLoader] = useState(false);
  const { product_name } = formData;
  const [selectedOption, setSelectedOption] = useState<any>();
  const userInfo = JSON.parse(sessionStorage.getItem("info"));

  useEffect(() => {
    fetchAllProductList();
  }, []);

  const handleDateChange = (date: any, dateString: string | string[]) => {
    if (typeof dateString === "string") {
      setSelectedDate(dateString);
    } else if (Array.isArray(dateString)) {
      console.error("Selected Dates:", dateString.join(", "));
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allProductListData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
    XLSX.writeFile(workbook, "Products List.xlsx");
  };

  const fetchAllProductList = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
        user_id: userInfo.id,
        user_type: userInfo.type,
      };
      const response = await getAllProductName(data);
      const ProductListData = response?.data?.map(
        (item: ProductListResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id,
          createdAt: formatDate(item.createdAt),
          product_name: item.product_name,
          type: item.type,
        })
      );
      setProductListData(ProductListData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "key",
      render: (_: any, record: ProductListData) => <div>{record.key}</div>,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: ProductListData) => (
        <div>{record.createdAt}</div>
      ),
    },
    {
      title: "Product Name",
      dataIndex: "product_name",
      render: (_: any, record: ProductListData) => (
        <div className="d-flex align-items-center">
          <div>{record.product_name}</div>
        </div>
      ),
      sorter: (a: ProductListData, b: ProductListData) =>
        a.product_name.localeCompare(b.product_name),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (_: any, record: ProductListData) => (
        <div className="d-flex align-items-center">
          <div>{record.type}</div>
        </div>
      ),
      sorter: (a: ProductListData, b: ProductListData) =>
        a.type.localeCompare(b.type),
    },
  ];
  const handleSubmit = async (event: any) => {
    setLoader(true);
    event.preventDefault();
    const payload = {
      product_name: product_name,
      type: selectedOption?.value,
      financer_id: userInfo.id,
    };
    try {
      const response = await addProductName(payload);
      if (response.status === true) {
        successAlert("Success", "successfully new plan created");
        setFormData(initialValues);
        setSuccessCreation(true);
        fetchAllProductList();
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Create New
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Search by Name\Mobile"
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {allProductListData && allProductListData.length > 0 && (
                  <Table
                    dataSource={allProductListData}
                    columns={columns}
                    Selection={true}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Product</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Product Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="product_name"
                            value={product_name}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Product Type <span className="text-danger"> *</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={[
                              { value: "Device Loan", label: "Device Loan" },
                              { value: "Others Loan", label: "Others Loan " },
                            ]}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="--Select--"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default ProductNameList;
